import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import LinkButton from 'flarum/common/components/LinkButton';
import classList from 'flarum/common/utils/classList';
import sortTags from 'flarum/tags/common/utils/sortTags';

export default class NavigationBar extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.tagItem = [];
    this.localeMainImgUrl = '';
    app.tagList.load(['children', 'lastPostedDiscussion', 'parent', 'wikiLabel', 'wikiLabel.wikiLabelOptions', 'wikiLabel.wikiLabelOptions.wikiLabelOptionsSon', 'wikiHeroDetailDiscussion', 'heroTagLatestdata' ,'heroTagLatestdata.heroTagHeroIntro' ,'heroTagLatestdata.heroTagHeroIntro.heroTagHeroLevel']).then(() => {
      this.tags = sortTags(app.store.all('tags').filter((tag) => !tag.isChild() && tag.pkgId() == app.data.pkgLogo.id));
      this.loading = false;
      m.redraw();
    });
    this.bodyClass = 'App--page';
    this.loading = true;
  }
  onupdate() {
    // var scrollArea = document.getElementById('navItems-ul');

    //   scrollArea.addEventListener('wheel', (event) => {
    //     event.preventDefault(); // Prevent default scrolling action
    //     scrollArea.scrollLeft -= event.deltaY * -1; // Scroll horizontally based on wheel delta
    //   }, { passive: false });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.setupWheelScrolling();
  }
  
  onremove(vnode) {
    super.onremove(vnode);
    this.cleanupWheelScrolling();
  }
  view(vnode) {
    return (
      <div className="sideNavContainer">
        <nav className="IndexPage-nav sideNav navItems navItems-lin">
          <ul id="navItems-ul">{listItems(this.navItems(vnode).toArray())}</ul>
        </nav>
      </div>
    );
  }

  navItems(vnode) {
    const items = new ItemList();
    const params = app.search.stickyParams();
    // this.activeButton = localStorage.getItem('activeButton') || 'allDiscussions';
    items.add(
      'allDiscussions',
      <LinkButton
        href={app.route('pages.home', params)}
        onclick={(e) => {
          const active = document.getElementsByClassName('item-allDiscussions')[0].classList.value.indexOf('active');
          if (active !== -1) {
            e.preventDefault(); // 阻止跳转
            return false; // 防止进一步处理
          }
        }}
      >
        <span className={classList(['navItem', vnode.attrs.routeName == 'pages.home' ? 'underline-yellow' : ''])}>
          {app.translator.trans('dl-index.forum.indexPage')}
        </span>
      </LinkButton>,
      100
    );

    // items.add(
    //   'plate',
    //   <LinkButton href={app.route('tags')}>
    //     <span className={classList(["navItem plate",
    //       vnode.attrs.routeName == 'tags' ? 'underline-yellow' : ''
    //     ])}>{app.translator.trans('dl_tag.forum.title')}</span>
    //   </LinkButton>,
    //   70
    // );
    if (!this.loading) {
      const pinned = this.tags.filter((tag) => {
        if (app.session.user) {
          return tag.position() !== null && tag.pkgId() == app.data.pkgLogo.id  && ((app.session.user.isAdmin() && (tag.isAdminLook() || !tag.isHidden())) || (!app.session.user.isAdmin() && !tag.isHidden()));
        } else {
          return tag.position() !== null && tag.pkgId() == app.data.pkgLogo.id  && !tag.isHidden();
        }
      })
      if (pinned && pinned.length > 0) {
        pinned
          .sort((a, b) => {
            return a.sortCount() - b.sortCount();
          })
          .forEach((element) => {
            let name = element.name();
            // 将字符串映射转换为 JavaScript 对象
            const obj = JSON.parse(name);
            // 创建 Map 对象并初始化
            const map = new Map(Object.entries(obj));
            // 获取特定键的值
            let localeName = map.get(app.data.locale);
            items.add(
              'tagItem' + element.id(),
              <LinkButton
                href={app.route('tag', { tags: element.slug() })}
                onclick={(e) => {
                  const active = document.getElementsByClassName(`item-tagItem${element.id()}`)[0].classList.value.indexOf('active');
                  if (active !== -1) {
                    e.preventDefault(); // 阻止跳转
                    return false; // 防止进一步处理
                  }
                }}
              >
                <span className={classList(['navItem plate', vnode.attrs.routeName == 'tag' ? 'underline-yellow' : ''])}>{localeName}</span>
              </LinkButton>,
              70
            );
          });
      }
    }

    return items;
  }
  setupWheelScrolling() {
    const scrollContainer = document.getElementById('navItems-ul');
    if (!scrollContainer || this.wheelHandlerAttached) return;
    
    const wheelHandler = (event) => {
      // 阻止默认的垂直滚动行为
      event.preventDefault();
      
      // 获取滚轮滚动的方向
      const delta = Math.max(-1, Math.min(1, (event.deltaY || -event.detail || event.wheelDelta)));
      
      // 设置滚动的速度和方向
      const scrollSpeed = 50; // 每次滚轮滚动的距离
      const scrollAmount = delta * scrollSpeed;
      
      // 水平滚动
      scrollContainer.scrollLeft += scrollAmount;
      
      // 添加动画效果
      this.smoothScrollTo(scrollContainer, scrollContainer.scrollLeft + scrollAmount);
    };
    
    // 添加滚轮事件监听
    scrollContainer.addEventListener('wheel', wheelHandler, { passive: false });
    
    // 标记已添加事件监听器
    this.wheelHandlerAttached = true;
    this.currentWheelHandler = wheelHandler;
    
    // 添加样式以隐藏垂直滚动条并启用水平滚动
    scrollContainer.style.overflowX = 'auto';
    scrollContainer.style.overflowY = 'hidden';
    
  }
  cleanupWheelScrolling() {
    const scrollContainer = document.getElementById('navItems-ul');
    if (scrollContainer && this.currentWheelHandler) {
      scrollContainer.removeEventListener('wheel', this.currentWheelHandler);
      this.wheelHandlerAttached = false;
      this.currentWheelHandler = null;
    }
  }
  smoothScrollTo(element, targetPosition, duration = 300) {
    const startPosition = element.scrollLeft;
    const distance = targetPosition - startPosition;
    let startTime = null;
    
    function animation(currentTime) {
      if (!startTime) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      
      // 使用缓动函数（这里使用easeOutQuad）
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      
      element.scrollLeft = startPosition + (distance * easeProgress);
      
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }
    
    requestAnimationFrame(animation);
  }
}
